import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Link,
} from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showPopupSnackbar } from "../../redux/actions/snackbarActions";
import { getAlertType, getToken } from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";
import { useStyles } from "../../Utils/Styles";
import AlertDialog from "./AlertDialog";

const server = EnvSettings.server;

export default function AlertMenu() {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();
  const [alerts, setAlerts] = useState([]);
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [dialogAlert, setDialogAlert] = useState();
  const [clearAll, setClearAll] = useState();
  const dispatch = useDispatch();
  const [note, setNote] = useState();

  const formatTime = (time) => {
    return time
      ? new Date(Date.parse(time) - new Date().getTimezoneOffset() * 60 * 1000)
          .toISOString()
          .substr(0, 19)
          .replace("T", " ")
      : "";
  };

  const handleAlert = (alert, index, accept) => {
    //    if (alert.alertType === 0) {
    if (accept === undefined) {
      setDialogAlert({ alert: alert, index: index });
      return;
    } else if (accept === false) {
      setDialogAlert(undefined);
      setOpen(false);
      return;
    }
    //    }
    alerts.pop(index);
    setOpen(false);
    setDialogAlert(undefined);
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        alert_id: alert.id,
        note: note,
      }),
    };
    fetch(server + "/handle_alert", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          var x = window.location.pathname;
          if (result.alert.alertType === 0) {
            dispatch(showPopupSnackbar({ error: false, message: "Success" }));
            return;
          }
          if (result.alert.TransportId) {
            history.push("/transports/" + result.alert.TransportId);
            if (x.includes("transports")) {
              window.location.reload();
            }
          } else {
            history.push("/monitoring/" + result.alert.createdAt.substr(0, 10));
            if (x.includes("monitoring")) {
              window.location.reload();
            }
          }
          //setAlerts(result.user.Company.Alerts)
        }
      });
  };

  const handleAllAlerts = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        all_alerts: true,
      }),
    };
    fetch(server + "/handle_alert", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          window.location.reload();
        }
      });
  };

  const getNotifications = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken(), seen: false }),
    };
    fetch(server + "/get_alerts", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          if (result.alerts) {
            setAlerts(result.alerts);
          }
        }
      });
  };

  useEffect(getNotifications, []);

  return (
    <div>
      <IconButton
        color="inherit"
        aria-haspopup="true"
        onClick={(e) => {
          if (alerts.length > 0) {
            setAnchorEl(e.currentTarget);
            setOpen(true);
          }
        }}
      >
        <Badge badgeContent={alerts.length} color="secondary">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div
          style={{
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 2,
            padding: 5,
          }}
        >
          <Link
            style={{ cursor: "pointer" }}
            onClick={() => {
              setClearAll(true);
            }}
          >
            <Typography style={{ textAlign: "center", fontWeight: "bold" }}>
              {t("alertMenu.clearAll")}
            </Typography>
          </Link>
        </div>
        {alerts.length > 0
          ? alerts.map((element, index) => (
              <MenuItem
                className={classes.alertItem}
                style={{ flexDirection: "column" }}
                onClick={() => {
                  handleAlert(element, index);
                }}
                key={element.id}
              >
                <Typography style={{ fontSize: 10 }}>
                  {formatTime(element.updatedAt)}
                </Typography>
                <Typography>
                  {element.Device?.deviceType === 0
                    ? null
                    : element.Device?.deviceType === 1
                    ? element.Device?.deviceName || element.Device?.serialNumber
                    : element.message
                    ? element.message
                    : element.Device?.deviceName ||
                      element.Device?.serialNumber}
                </Typography>
                <Typography>{getAlertType(element.alertType, t)}</Typography>
              </MenuItem>
            ))
          : undefined}
      </Menu>
      <Dialog
        open={clearAll}
        onClose={() => {
          setClearAll(false);
        }}
      >
        <DialogTitle>{t("alertMenu.confirmClear")}</DialogTitle>
        <DialogActions>
          <Button
            onClick={() => {
              handleAllAlerts();
              setClearAll(false);
            }}
          >
            <Typography>{t("yes")}</Typography>
          </Button>
          <Button
            onClick={() => {
              setClearAll(false);
            }}
          >
            <Typography>{t("no")}</Typography>
          </Button>
        </DialogActions>
      </Dialog>
      {dialogAlert ? (
        <AlertDialog
          alertData={dialogAlert}
          handleAnswer={handleAlert}
          setNote={setNote}
        />
      ) : undefined}
    </div>
  );
}
